<style>
.finanzas .theme--light.v-select .v-select__selection--disabled{
    color:red;
}
.finanzas .theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea{
 color:red;   
}
.theme--light.v-divider{
     border-color: rgb(6,71,123,45%);   
}
</style>
<template >
    <v-container fluid>
        <v-layout style="flex-direction: column;">
            <v-row>
                <v-data-table 
                :headers="HeaderBuySellLista"
                :items="BuySellLista"        
                :search="search"
                class="elevation-3"
                style="border-radius: 6px;width: 100%;"
                id="TableBuy"
                :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'skip_previous',
                    lastIcon: 'skip_next',
                    prevIcon: 'keyboard_arrow_left',
                    nextIcon: 'keyboard_arrow_right'
                }"
                >
                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-row>
                                <v-col style="display: flex;align-items: center;" sm="2" md="2" lg="2" xl="2" >
                                    <v-toolbar-title>Search </v-toolbar-title>
                                    <v-divider
                                        class="mx-4"
                                        inset
                                        vertical
                                    ></v-divider>
                                </v-col>
                                <v-col style="display: flex;" sm="3" md="3" lg="2" xl="2" >
                                    <v-select label="Select." style="margin-top:20px;width:125px;" v-model="buscarpor" dense outlined :items="busqueda"></v-select>
                                </v-col>
                                <v-col style="display: flex;" sm="5" md="5" lg="3" xl="3" >
                                    <v-text-field style="margin-top:20px;margin-left:12px;" class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" ></v-text-field>
                                </v-col>
                                <v-col style="display: flex;align-items: center;" sm="2" md="2" lg="2" xl="2" >
                                    <v-btn color="primary" @click="listar">Search</v-btn>
                                </v-col>
                            </v-row>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.opciones="{ item }">
                            <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">                    
                                <v-icon
                                v-bind="attrs"
                                v-on="on"
                                    small
                                    class="mr-2"
                                    @click="editItemBS(item)" 
                                    style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                    color="#3d5170"
                                    >
                                    edit
                                </v-icon>
                            </template>
                            <span>Edit</span>
                        </v-tooltip>
                    </template>
            </v-data-table>
            </v-row><br>
            <v-row>
                <v-card style="width: 100%;" v-if="viewdatos == true">
                    <v-card-text>
                        <v-col sm="12" md="12" lg="12" xl="12" >
                            <div id="Impresion" style="width: 100%;color: black;padding: 12px;">
                                    <br>
                                    <section style="width: 100%;">
                                        <table class="imprimir" style="width: 100%;border-collapse: collapse;font-size: 8pt;">
                                            <tr class="headeroscar">
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>EXECUTIVE</span>
                                                </td>
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>Bs Number.</span>
                                                </td>
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span v-if="editBS.idbasis == 3 || editBS.idbasis == 4">Inland N°.</span>
                                                    <span v-else>OSCAR N°.</span>
                                                </td>
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>BASIS</span>
                                                </td>
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>PLACE OF RECEIPT</span>
                                                </td>
                                                <td v-if="editBS.idbasis ==1  || editBS.idbasis == 2 || editBS.idbasis == 5" style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>PORT OF LOADING</span>
                                                </td>
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>POL ETD</span>
                                                </td>
                                                <td v-if="editBS.idbasis ==1  || editBS.idbasis == 2 || editBS.idbasis == 5" style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>PORT OF DISCHARGE</span>
                                                </td>
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>POD ETA</span>
                                                </td>
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>PLACE OF DELIERY</span>
                                                </td>
                                                <!--<td>
                                                    <span>MODALITY</span>
                                                </td>-->
                                                <td v-if="editBS.idbasis ==1  || editBS.idbasis == 2 || editBS.idbasis == 5" style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>VESSEL/VOYAGE</span>
                                                </td>
                                                <!--<td>
                                                    <span>VESSEL/VOYAGE TRANSHIPMENT.</span>
                                                </td>-->
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>SHIPPENG LINE </span>
                                                </td>
                                                <td style="background-color: rgb(202,224,249);padding: 4px;font-weight: 500;border: 1px solid #74a7e0;">
                                                    <span>OPTIMA'S AGENT </span>
                                                </td>
                                            </tr>
                                            <tr class="headerinfo">
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{editBS.nombreus}}</span>
                                                </td>
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{editBS.nbuysell}}</span>
                                                </td>
                                                <td style="fpadding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{numoscar}}</span>
                                                </td>
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{editBS.basis}}</span>
                                                </td>
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{editBS.receipt}}</span>
                                                </td>
                                                <td v-if="editBS.idbasis ==1  || editBS.idbasis == 2 || editBS.idbasis == 5" style="fpadding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{editBS.loading}}</span>
                                                </td>
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span v-if="editBS.idbasis ==1  || editBS.idbasis == 2 || editBS.idbasis == 5">{{editBS.fechaetd}}</span>
                                                    <span v-else>{{editBS.fechaareceipt}}</span>
                                                </td>
                                                <td v-if="editBS.idbasis ==1  || editBS.idbasis == 2 || editBS.idbasis == 5" style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{editBS.discharge}}</span>
                                                </td>
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span v-if="editBS.idbasis ==1  || editBS.idbasis == 2 || editBS.idbasis == 5">{{editBS.fechaeta}}</span>
                                                    <span v-else>{{editBS.fechadelivery}}</span>
                                                </td>
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{editBS.delivery}}</span>
                                                </td>
                                                <!--<td>
                                                    <span></span>
                                                </td>-->
                                                <td v-if="editBS.idbasis ==1  || editBS.idbasis == 2 || editBS.idbasis == 5" style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span v-if="editBS.nvessel!='SELECT..'">{{editBS.nvessel}} / </span><span v-else>--</span> <span >{{editBS.voyage}}</span>
                                                </td>
                                                <!--<td>
                                                    <span></span>
                                                </td>-->
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                     <span>{{editBS.nprovider}}</span>
                                                </td>
                                                <td style="padding: 4px;text-align: center;border: 1px solid #cae0f9;">
                                                    <span>{{editBS.nagent}}</span>
                                                </td>
                                            </tr>
                                        </table>
                                        <br>
                                        <div style="display: flex;" v-if="editBS.idbasis ==1  || editBS.idbasis == 3">
                                            <v-simple-table style="width: 45%;border-collapse: collapse;font-size: 8pt;">
                                                <thead>
                                                    <th style="background-color: rgb(202,224,249);padding: 2px;font-weight: 500;border: 1px solid #74a7e0;"><span>CONTAINER NUMBER</span></th>
                                                    <th style="background-color: rgb(202,224,249);padding: 2px;font-weight: 500;border: 1px solid #74a7e0;">SIZE</th>   
                                                    <th style="background-color: rgb(202,224,249);padding: 2px;font-weight: 500;border: 1px solid #74a7e0;">TYPE</th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="det in tarifasListarinfo" :key="det.num">
                                                        <td v-if="det.size != 10" style="padding: 2px;text-align: center;border: 1px solid #cae0f9;">{{det.containernumber}}</td>
                                                        <td v-if="det.size != 10" style="padding: 2px;text-align: center;border: 1px solid #cae0f9;"><span v-if="det.size != 'SELECT..'">{{det.size}}</span><span v-else>-</span></td>
                                                        <td v-if="det.size != 10" style="padding: 2px;text-align: center;border: 1px solid #cae0f9;"><span v-if="det.size != 'SELECT..'">{{det.type}}</span><span v-else>-</span></td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </div>
                                    </section>
                                    <section class="finanzas">
                                         <v-card style="margin-top:8px;" elevation="4">
                                            <v-card-text>
                                                <v-row>
                                                    <v-card elevation="2" >
                                                    <v-card-text > <br>
                                                        <span class="titleogl">Charges highlights</span>
                                                        <v-row dense style="margin-top: 16px;">
                                                            <v-col sm="2" md="2" lg="2"><v-select disabled style="color:red;" outlined dense return-object item-text="text" item-value="value" label="*Type" v-model="editedbuysell.idinstance" :items="buys" ></v-select></v-col>
                                                            <v-col sm="2" md="2" lg="2"><v-select disabled  outlined dense return-object item-text="text" item-value="value" label="* Description" v-model="editedbuysell.idcharge" :items="charges"></v-select></v-col>
                                                            <v-col sm="3" md="3" lg="3"> <v-text-field dense outlined label="Invoice Number" v-model="editedbuysell.invoicen" background-color="rgb(255,0,0,30%)"></v-text-field> </v-col>
                                                            <v-col sm="2" md="2" lg="2"> <v-btn color="primary" @click="addinvoice" >Add</v-btn></v-col>
                                                        </v-row>
                                                        <v-row style="align-items: center;" dense>
                                                            <v-col sm="4" md="3" lg="3"><v-select disabled outlined dense return-object item-text="text" item-value="value" label="* Provider/Entity" v-model="editedbuysell.idprovider" :items="provider"></v-select></v-col>
                                                            <v-col sm="3" md="2" lg="2"><v-select disabled outlined dense return-object item-text="text" item-value="value" label="* Currency" v-on:change="Tipocambio"  v-model="editedbuysell.idmoneda" :items="monedas"></v-select></v-col>
                                                            <v-col sm="3" md="2" lg="2"><v-text-field outlined dense disabled regular label="* Rate Exchange" v-model="editedbuysell.idtipocambio"></v-text-field></v-col>
                                                            <v-col sm="2" md="2" lg="2"><v-text-field disabled outlined dense prefix="$" v-model="editedbuysell.rate" label="Rate"></v-text-field></v-col>
                                                            <v-col sm="1" md="1" lg="1"><v-select disabled outlined dense return-object item-text="text" item-value="value" label="IVA" v-model="editedbuysell.idiva" :items="ivas"></v-select></v-col>
                                                            <v-col sm="1" md="1" lg="1">
                                                                <v-checkbox
                                                                disabled
                                                                v-model="cobrarpesos"
                                                                label="Cobrar/pagar pesos"
                                                                ></v-checkbox>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row style="align-items: baseline;" dense>
                                                            <v-col sm="2" md="2" dense>
                                                                <span>*Per</span>
                                                                <v-radio-group disabled dense v-model="editedbuysell.idper" :mandatory="false">
                                                                    <v-radio label="Prepaid" value="Prepaid"></v-radio>
                                                                    <v-radio label="Collect" value="Collect"></v-radio>
                                                                </v-radio-group>
                                                            </v-col>
                                                            <v-col sm="2" md="2" dense>
                                                                <span>*Payment by</span>
                                                                <v-radio-group disabled dense v-model="editedbuysell.payment" :mandatory="false">
                                                                    <v-radio :disabled="LclLtl" dense label="Shipment" value="shipment"></v-radio>
                                                                    <v-radio :disabled="LclLtl" dense label="Container(s)" value="container"></v-radio>
                                                                    <v-radio dense label="TON/m3" value="TON/m3"></v-radio>                                                
                                                                </v-radio-group>
                                                            </v-col>
                                                            <v-col >
                                                                <v-row>
                                                                    <v-col sm="2" md="2">
                                                                        <v-text-field disabled label="number" type="number" v-model="numbercont" outlined dense></v-text-field>
                                                                    </v-col>
                                                                    <v-col  sm="4" md="3">
                                                                        <v-select  disabled outlined dense return-object item-text="text" item-value="value" label="* Container Size" v-model="editedbuysell.idtamano" :items="tamanoc"></v-select>
                                                                    </v-col>
                                                                    <v-col sm="4" md="3">
                                                                        <v-select  disabled outlined dense return-object item-text="text" item-value="value" label="* Container Type" v-model="editedbuysell.idcontenedor" :items="tipoc">                                                                
                                                                        </v-select>
                                                                    </v-col>
                                                                    <v-col sm="11" md="8">
                                                                        <v-textarea disabled dense outlined v-model="editedbuysell.notas" label="Notes"></v-textarea>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                                </v-row>
                                                <v-row>
                                                    <span style="font-weight: 600;color: #1565C0;width: 100%;font-size: smaller;margin-bottom: 5px;text-align: center;">CHARGES SELL DETAILS </span>
                                                    <v-data-table
                                                        v-model="selectedcostos"
                                                        :headers="headersbs"
                                                        :items="buysellst"        
                                                        :single-select="singleSelectcostos"
                                                        show-select
                                                        item-key="idchargebs"
                                                        class="elevation-1 datalistar"
                                                        dense
                                                    >
                                                        <template v-slot:item.opciones="{ item }">
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">                    
                                                                    <v-icon
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                        small
                                                                        class="mr-2"
                                                                        @click="editItemBSChS(item)" 
                                                                        style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                        color="#3d5170"
                                                                        >
                                                                        edit
                                                                    </v-icon>
                                                                </template>
                                                                <span>Edit</span>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-data-table>
                                                </v-row><br>
                                                <v-row>
                                                    <v-btn style="display: flex;flex-direction: row-reverse;" color="primary" @click="guardar()">guardar</v-btn>
                                                </v-row>
                                            </v-card-text>
                                        </v-card>
                                    </section>
                                </div>
                        </v-col>
                    </v-card-text>
                </v-card>
            </v-row>
        </v-layout>
        <v-snackbar
            v-model="snackbar"
            bottom
            :color="colorm"
            :timeout = 8000
            top
            vertical
        >
            {{ mensaje }}
            <template >
                <v-btn dark text @click="snackbar = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
        <v-dialog
            v-model="dialodload"
            hide-overlay
            persistent
            width="300"
        >
            <v-card 
            color="primary"
            dark
            >
                <v-card-text><br>
                    Please stand by
                <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                ></v-progress-linear>                    
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import axios from 'axios'
export default {
    data(){
        return{
            dialodload:false,
            viewdatos:false,
            snackbar:false,
            colorm:'',
            mensaje:'',
            selectedcostos:[],
            singleSelectcostos: false,
            numbercont:0,
            LclLtl:false,
            cobrarpesos:'',
            Searhco:'Oscar',
            search:'',
            textio:'3',
            HeaderBuySellLista:[
                {text:'',value:'opciones',align:'center'},
                {text:'BS NUMBER',value:'nbuysell',align:'center'},
                {text:'-',value:'nreference',align:'center'},
                {text:'CUSTOMER NAME',value:'custumer',align:'center'},
                {text:'OPERATION TYPE',value:'tipoOp',align:'center'},
                {text:'BASIS',value:'basis',align:'center'},
                {text:'MODALITY',value:'modalidad',align:'center'},
                {text:'PLACE OF RECEIPT',value:'receipt',align:'center'},
                {text:'POL',value:'loading',align:'center'},
                {text:'POD',value:'discharge',align:'center'},
                {text:'FINAL DESTINATION',value:'delivery',align:'center'},
            ],
            BuySellLista:[],
            busqueda:[
                {text:'Bs',value:1},
                {text:'Oscar',value:2},
                {text:'Inland',value:3}
            ],
            fechaHoy:null,
            editBS:{
                idusuario:0,
                idmodalidad:0,
                idbasis:0,
                idtipoOp:0,
                idinland:0,
                insurance:0,        
                customs:0,
                vgm:0,                
                idcustumer:0,
                btcredit:[],
                creditDays:'',
                commodity:'',
                fahscode:'',
                btnhazardous:[],
                hazardous:'',
                idprovider:0,
                qt:'',
                idportreceipt:0,
                datereceipt:null,
                idportloading:0,
                idportdischarge:0,
                idportdelivery:0,
                datedeliviry:null,
                freedaysoriginB:'',
                freedaysoriginS:'',
                idvessel:0,
                voyage:'',
                freedaysdestB:'',
                freedaysdestS:'',
                fechaeta:null,
                fechaetd:null,
                remarks:'',
                idagent:{text:'No Aplica',value:'15'},
                class1:'',           
                un:'',
                fechaareceipt:'',
                fechadelivery:'',
                reference:'',
                dentrodebl:1,
            },  
            editedbuysell:{
                invoicen:'',
                idinstance:0,
                instance:'',
                idcharge:0,
                charge:'',
                idprovider:0,
                priovider:'',
                idmoneda:1,
                moneda:'',
                idtipocambio:1,
                idtc:1,
                rate:'',
                iva:'NA',
                ivacant:0,
                idiva:2,
                idper:'Prepaid',
                per:'',
                payment:'shipment',
                idtamano:0,
                tamanoc:'',
                idcontenedor:0,
                tipoc:'',
                notas:'',
                prepaid:0,
                collect:0,
                total:0,
                quantity:0,
                cobrarenpesos:false,
            },  
            idtc:0,
            buysellst:[],
            buysellBt:[],
            buysellB:[],
            containers: [],
            addpackages:[],
            idtotalsell1:0,
            idtotalsell:0,
            idtotalbuy1:0,
            idtotalbuy:0,
            idtotal1:0,
            idtotal:0,
            totalsell:0,
            totalbuy:0,
            totalprofit:0,
            totalselliva:0,
            totalbuyiva:0,
            totalprofitiva:0,
            numoscar:'',
            buscarpor:'',
            tarifasListarinfo:[],
            buys:[],
            charges:[],
            provider:[],
            monedas:[],
            ivas:[],
            tamanoc:[],
            tipoc:[],
            editedIndexchs:-1,
            headersbs:[
                {text:'OPTIONS',value:'opciones',align:'center',width:100,sortable:false},
                {text:'TYPE',value:'buysell',align:'center',sortable:false},
                {text:'PROVIDER',value:'provider',align:'center',sortable:false},
                {text:'DESCRIPTION',value:'charge',align:'center',sortable:false},
                {text:'PER',value:'per',align:'center',sortable:false},
                {text:'CURRENCY',value:'moneda',align:'center',sortable:false},
                {text:'PREPAID',value:'prepaid',align:'center',sortable:false},
                {text:'COLLECT',value:'collect',align:'center',sortable:false},
                {text:'NOTES',value:'notas',align:'center',maxwidth:200,sortable:false},
                {text:'#CONTAINERS',value:'numbercont',align:'center',maxwidth:200,sortable:false},
                {text:'INVOICE',value:'invoice',align:'center'},
                {text:'CONTAINER SIZE',value:'tamanoc',align:'center',sortable:false},
                {text:'CONTAINER TYPE',value:'tipoc',align:'center',sortable:false},
                {text:'RATE EXCHAGE',value:'rate',align:'center',sortable:false},
                {text:'IVA',value:'iva',align:'center',sortable:false},
                {text:'TOTAL',value:'total',align:'center',sortable:false},
            ],
            searchb:'' ,
            searchs:'',
            buysells:[],
        }
    },
    created(){
        this.select();
    },
    methods:{
        select(){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var basiss = [];                
            var tipoOp = [];
            var inlandArray = [];
            var modalidadArray = [];
            var customerArray = [];
            var providerArray = [];
            var monedasArray = [];
            var chargesArray = [];
            var bsArray = [];
            var tamanocArray = [];
            var tipocArray = [];
            var portArray = [];
            var vesselArray = [];
            var agentArray = [];
            var ivaArray = [];
            var packageArray = [];
            var longitudArray = []; 
            var masaArray = [];
            var usuariosarray = [];
            var shippinarray = [];
            axios.get('api/Tipocontenedores/select',configuracion).then(function(response){            
                tipocArray=response.data;
                tipocArray.map(function(x){
                    me.tipoc.push({text:x.tipocontenedor,value:x.idcontenedor});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/tamanocontenedores/select',configuracion).then(function(response){            
                tamanocArray=response.data;
                tamanocArray.map(function(x){
                    me.tamanoc.push({text:x.tamanocontenedor,value:x.idtamano});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/ivas/Select',configuracion).then(function(response){            
                ivaArray=response.data;
                ivaArray.map(function(x){
                    me.ivas.push({text:x.nombre + "%" ,value:x.idiva} );
                });            
            }).catch(function(error){
            console.log(error);
            });
            axios.get('api/Monedas/select',configuracion).then(function(response){            
                monedasArray=response.data;
                monedasArray.map(function(x){
                    me.monedas.push({text:x.abreviatura,value:x.idmoneda});
                });            
            }).catch(function(error){
                console.log(error);
            }); 
            axios.get('api/Instances/select',configuracion).then(function(response){            
                bsArray=response.data;
                bsArray.map(function(x){
                    me.buys.push({text:x.nombre,value:x.idinstance});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Charges/select',configuracion).then(function(response){            
                chargesArray=response.data;
                chargesArray.map(function(x){
                    me.charges.push({text:x.nombre,value:x.idcharge});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Datos/SelectProveedor',configuracion).then(function(response){            
                providerArray=response.data;
                providerArray.map(function(x){
                    me.provider.push({text:x.nombre,value:x.iddatos});
                });            
            }).catch(function(error){
                console.log(error);
            });
               
        },
        Tipocambio(){
            console.log('Entra tipo de cambio')
            console.log(this.editedbuysell.idmoneda.value) 
            if(this.editedbuysell.idmoneda.value == 1){                        
                this.editedbuysell.idtipocambio = 1;
                this.idtc = 1;
            }else{
                let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
                let header={"Authorization" : "Bearer " + this.$store.state.token};
                var rateArray = [];
                let configuracion ={headers:header};
                axios.get('api/Tipocambios/Listartc/'+ me.editedbuysell.idmoneda.value,configuracion).then(function(response){            
                    rateArray=response.data;
                    console.log('rateArray')
                    console.log(rateArray)
                    rateArray.map(function(x){
                        me.editedbuysell.idtipocambio = x.tipodecambio;
                        me.idtc = x.idtipocambio;
                    });                                      
                }).catch(function(error){
                console.log(error);
                });           
            }            
        },
        listar(){//mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            me.dialodload = true;
            me.BuySellLista = [];
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var consulta ='';
            console.log(me.buscarpor)
            if(me.buscarpor == 1){
                consulta = 'api/Buysells/ListarBS/';
            }
            if(me.buscarpor == 2){
                consulta = 'api/Oscars/BuscarOscarInvoice/';
            }
            if(me.buscarpor == 3){
                consulta = 'api/InlandDatos/BuscarInland/';
            }
            axios.get(consulta + me.search,configuracion).then(function(response){                
                me.BuySellLista=response.data;
                console.log(me.BuySellLista)
                if(me.BuySellLista.length <= 0){
                    me.colorm ='error'
                    me.snackbar = true            
                    me.mensaje = 'Datos no encontrados'
                }else{
                    me.search = '';
                    me.buscarpor = '';
                }
                me.dialodload = false;
            }).catch(function(error){
                console.log(error);
            });
        },
        editItemBS(item) {
            this.limpiar();
            this.dialodload = true;
            this.editedIndexbuys = this.BuySellLista.indexOf(item)               
            this.editBS = Object.assign({}, item)
            if(this.editBS.idbasis == 3 || this.editBS.idbasis == 4){
                this.InlandExists(this.editBS.idbs);
            }else{
                this.OscarExists(this.editBS.idbs);
            }
            this.informaciondeembarque();
        },
        guardar(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;
            axios.put('api/Buysells/ActualizarInvoice',{
                'idbs':model.editBS.idbs,
                'chargebssell':model.buysellst,
            },configuracion).then(function(response){
                model.colorm ='info'
                model.snackbar = true            
                model.mensaje = model.editBS.nbuysell + 'Actualizada correctamente'
                model.limpiar();
                //model.listar();
                model.viewdatos = false;
                model.dialodload = false;
                model.buysellst = [];
            }).catch(function(error){
                console.log(error);
                model.colorm ='error'
                model.snackbar = true            
                model.mensaje = 'Error al actualizar la Bs' + error
                model.dialodload = false;
            }); 
        },
        cargarentities(id){
            console.log('entra entity')
            console.log(id)
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var providerArray = [];                
            me.provider = [];
            axios.get('api/Enlace_Cliente_Proveedor/Select/'+ id,configuracion).then(function(response){            
                console.log(providerArray)
                providerArray=response.data;
                providerArray.map(function(x){
                    me.provider.push({text:x.nombre,value:x.idprovedor});
                });            
            }).catch(function(error){
                console.log(error);
            });
        },
        addinvoice(){
            if(this.editedIndexchs > -1){
                Object.assign(this.buysellst[this.editedIndexchs],{
                    invoice:this.editedbuysell.invoicen,
                })
                this.limpiar();
                
            }else{
                if(this.selectedcostos.length >= 1){
                    for(var  n = 0; n < this.buysellst.length; n++){
                        for(var i = 0; i < this.selectedcostos.length; i++){
                            if(this.buysellst[n].id == this.selectedcostos[i].id){
                                Object.assign(this.buysellst[n],{
                                    invoice:this.editedbuysell.invoicen,
                                })
                            }
                        }
                    }
                    this.limpiar();
                }else{

                }
            }
        },
        limpiar(){
            this.editedbuysell.buysell = '';
            this.editedbuysell.idinstance = '';
            this.editedbuysell.charge = '';
            this.editedbuysell.idcharge = '';
            this.editedbuysell.idprovider = '';
            this.editedbuysell.provider = '';
            this.editedbuysell.per = '';
            this.editedbuysell.idper = '';
            this.editedbuysell.payment = '';
            this.editedbuysell.idmoneda = '';
            this.editedbuysell.moneda = '';
            this.editedbuysell.prepaid = '';
            this.editedbuysell.collect = '';
            this.editedbuysell.notas = '';
            this.editedbuysell.idtamano = '';
            this.editedbuysell.tamanoc = '';
            this.editedbuysell.idcontenedor = '';
            this.editedbuysell.tipoc = '';
            this.editedbuysell.idtipocambio = '';
            this.editedbuysell.rate = '';
            this.editedbuysell.iva = '';
            this.editedbuysell.idiva = '';
            this.editedbuysell.total = '';
            this.editedbuysell.totalmxn = '';
            this.editedbuysell.cobrarenpesos =  '';
            this.editedbuysell.quantity = '';
            this.editedbuysell.ivacant = '';
            this.editedbuysell.invoicen = '';
            this.editedIndexchs = -1;
            this.selectedcostos = [];
            this.tarifasListarinfo = [];
        },
        editItemBSChS(item){
            this.cargarentities(this.editBS.idcustumer);
            this.editedIndexchs = this.buysellst.indexOf(item)
            var total = 0;
            var idmoneda = 0;
            var tc = 0;
            this.idtc = item.idtipocambio;
            if(Number(item.totalmxn) !=0){
                total =Number( item.totalmxn)
                idmoneda = 2;
                tc = item.rate;
            }else{
                if( Number(item.prepaid) != 0){
                    total = Number(item.prepaid);
                }
                if(Number(item.collect)!= 0){  
                    total = Number(item.collect);
                }
                idmoneda = item.idmoneda;
                tc = 1;
            }
                this.editedbuysell.buysell = item.buysell;
                this.editedbuysell.idinstance = item.idinstance;
                this.editedbuysell.charge = item.charge;
                this.editedbuysell.idcharge = item.idcharge;
                this.editedbuysell.idprovider = item.idprovider; 
                this.editedbuysell.provider = item.provider;
                this.editedbuysell.per = item.per;
                this.editedbuysell.idper = item.idper;
                this.editedbuysell.payment = item.payment;
                this.editedbuysell.idmoneda = idmoneda;
                this.editedbuysell.moneda = item.moneda;
                this.editedbuysell.prepaid = item.prepaid;
                this.editedbuysell.collect = item.collect;
                this.editedbuysell.notas = item.notas;
                this.editedbuysell.idtamano = item.idtamano;
                this.editedbuysell.tamanoc = item.tamanoc;
                this.editedbuysell.idcontenedor = item.idcontenedor;
                this.editedbuysell.tipoc = item.tipoc;
                this.editedbuysell.idtipocambio = tc;
                this.editedbuysell.rate = total;
                this.editedbuysell.iva = item.iva;
                this.editedbuysell.idiva = item.idiva;
                this.editedbuysell.total = item.total;
                this.editedbuysell.totalmxn = item.totalmxn;
                this.editedbuysell.cobrarenpesos = item.cobrarenpesos;
                this.editedbuysell.quantity = item.quantity;
                this.editedbuysell.ivacant = item.ivacant;
                this.editedbuysell.invoicen = item.invoice;
        },
        viewoscar(){
            if(this.editBS.idbasis == 3 || this.editBS.idbasis == 4){
                this.InlandExists(this.editBS.idbs);
            }else{
                this.OscarExists(this.editBS.idbs);
            }
            this.informaciondeembarque();
        },
        InlandExists(id){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var InlandDatos;
            var idinland;
            me.numoscar = 'Pendiente';
            axios.get('api/InlandDatos/ListarInland/'+id,configuracion).then(function(response){                
                InlandDatos=response.data;
                InlandDatos.map(function(x){
                    me.numoscar = x.ninland,
                    idinland = x.idinland
                });
                    
                me.CargarInformacionIn(idinland,1)
                me.ListarChargeBST(me.editBS.idbs)
            }).catch(function(error){
                console.log(error);
            });
        },
        OscarExists(id){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var oscar = [];
            var idoscar;
            me.numoscar = 'Pendiente';
            axios.get('api/Oscars/BuscarOscarInvoice/'+ id,configuracion).then(async function(response){                
                oscar=response.data;
                    oscar.map(function(x){
                        me.numoscar = x.oscarnum,
                        idoscar = x.idoscar
                    })
                    me.CargarInformacion(idoscar,1);
                    me.ListarChargeBST(me.editBS.idbs)
                }).catch(function(error){
                    console.log(error);
                });
        },
        async CargarInformacion(id,generado){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var container = [];
             me.tarifasListar = [];
             me.infcontainers = [];
             console.log('ID oscar ' + id)
            if(generado == 1){
                axios.get('api/Containers_pack_oscar_ogl/ListarContainersOscar/'+ id,configuracion).then(async function(response){                
                container=response.data;
                    var i;
                    var idsize = 0;
                    for(i = 0; i < container.length; i++){
                        if(idsize != container[i].idsize){
                            me.infcontainers.push({
                              number:container.length,
                                idsize:container[i].idsize,
                                idtype:container[i].idtype,
                                weight:'',
                            });
                        }
                        idsize = container[i].idsize;
                        me.tarifasListar.push({
                            num:i+1,
                            idcontainer:container[i].idcontainer,
                            qty:container[i].qty,
                            idpackage:container[i].idpackage,
                            size:container[i].size,
                            type:container[i].type,
                            idsize:container[i].idsize,
                            idtype:container[i].idtype,
                            qtycontainers:container[i].qtycontainers,
                            containernumber:container[i].containernumber,
                            sel:container[i].sel,
                            vol:container[i].vol,
                            ngross:me.addCommas(parseFloat(container[i].gross).toFixed(2)) + " Kg.",
                            gross:container[i].gross,
                            hbln:container[i].hbln,
                            idhbl:container[i].idhbl,
                            idhbln:container[i].idhbln,
                            mbln:container[i].mbln,
                            idmbl:container[i].idmbl,
                            idmbln:container[i].idmbln,
                            description:container[i].description,
                            length:container[i].length,
                            width:container[i].width,
                            height:container[i].height,
                            activo:true,
                        })
                    }
                    me.cargarinfocontainer();
                }).catch(function(error){
                    console.log(error);
                }); 
            }else{
                axios.get('api/DatosContainerUnits/ListarContainersBs/'+ id,configuracion).then(async function(response){
                container=response.data;
                    var i;
                    container.map(async function(x){
                         me.infcontainers.push({
                            number:x.quantity,
                            idsize:x.idsize,
                            idtype:x.idtype,
                            weight:me.addCommas(x.weight),
                        });
                        for(i = 0; i < x.quantity; i++){
                            me.tarifasListar.push({
                                num:i+1,
                                qty:'',
                                idpackage:0,
                                size:x.size,
                                type:x.type,
                                idsize:x.idsize,
                                idtype:x.idtype,
                                qtycontainers:'',
                                containernumber:'',
                                description:'',
                                sel:'',
                                vol:'',
                                idhbln:'',
                                ngross:me.addCommas(parseFloat(x.weight).toFixed(2)) + " Kg.",
                                gross:x.weight,
                                hbln:'',
                                idhbl:0,
                                idmbln:'',
                                mbln:'',
                                idmbl:0,
                                length:0,
                                width:0,
                                height:0,
                                activo:true,
                            })
                        }
                    });
                    me.cargarinfocontainer();
                }).catch(function(error){
                    console.log(error);
                });
            }  
        },
        CargarInformacionIn(id,generdo){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var container = [];
            me.infcontainers = [];
            me.tarifasListar = [];
            if(generdo == 1)
            {
                axios.get('api/InlandUnits/ListarContainers/'+ id,configuracion).then(function(response){
                    container=response.data;
                    var i = 0;
                    var n = 0;
                    console.log('container datos')
                    console.log(container)
                    var  size = 0;
                    container.map(function(x){
                        n = n + 1;
                        me.tarifasListar.push({
                                idinlandunit:x.idinlandunit,
                                idcontainer:x.idcontainer,
                                idpackage:'',
                                idpackagen:'',
                                num:n,
                                qty:n,
                                size:x.size,
                                type:x.type,
                                idsize:x.idsize,
                                idtype:x.idtype,
                                containernumber:x.equipmentnumber,
                                sel:x.seal,
                                vol:x.volumen,
                                grossweight:me.addCommas(x.grossweight) ,
                                comentarios:'',
                                hbln:'',
                                idhbl:0,
                                idmbln:'',
                                mbln:'',
                                idmbl:0,
                                activo:true,
                            })
                            if(size != x.idsize){
                                console.log('entra container info')
                                me.infcontainers.push({
                                    idcontainer:x.idcontainer,
                                    number:container.length,
                                    idsize:x.idsize,
                                    idtype:x.idtype,
                                    weight:me.addCommas(x.grossweight),
                                });
                                size = x.idsize;
                            }
                        i = i + 1;
                        //me.containerunit.push({text:x.size + " " + x.type ,value:x.idcontainer});
                    }) 
                    me.ListarChargeBS(me.editBS.idbs);
                    me.cargarinfocontainer()
                }).catch(function(error){
                    console.log(error);
                });
            }else{
                axios.get('api/DatosContainerUnits/ListarContainersBs/'+ id,configuracion).then(function(response){                
                container=response.data;
                var i;
                var n = 0;
                container.map(function(x){
                    me.infcontainers.push({
                        idcontainer:x.idcontainer,
                        number:x.quantity,
                        idsize:x.idsize,
                        idtype:x.idtype,
                        weight:me.addCommas(x.weight),
                    });
                    for(i = 0; i < x.quantity; i++){
                     me.inlandst.push({
                            idcontainer:x.idcontainer,
                            num:n,
                            qty:i+1,
                            size:x.size,
                            type:x.type,
                            idsize:x.idsize,
                            idtype:x.idtype,
                            enumber:'',
                            seal:'',
                            volumen:'',
                            grossweight:me.addCommas(x.weight),
                            comentarios:'',
                            activo:true,
                        })
                        n= n + 1;
                    }
                    //me.containerunit.push({text:x.size + " " + x.type ,value:x.idcontainer});
                })    
            }).catch(function(error){
                    console.log(error);
                });
            }
        },
        async ListarChargeBST(idbs){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this; 
            var buy=[];
            var sell=[]
            me.buysellBt = [];
            me.buysellst = [];
            var i;
            var n;
            var tbuy = 0;
            var tsell = 0;
            var total = 0;
            var tbuyiva = 0;
            var tselliva = 0;
            var totaliva = 0;
            me.totalsell = 0;
            me.totalbuy = 0;
            me.totalprofit = 0;
            me.totalselliva = 0;
            me.totalbuyiva = 0;
            me.totalprofitiva = 0;
            me.costossell = [];
            var an=0;
            var ans=0;
            setTimeout(function(){
                axios.get('api/chargesBS/ListarChargesBuy/' + idbs,configuracion).then(async function(response){
                    buy=response.data;
                    buy.map(async function(x){
                        var totalmxn = 0;
                        if(x.cobrarenpesos == true){
                            totalmxn = me.addCommas(x.totalmxn);
                        } 
                        if(x.payment == 'container'){
                            //for(i=0; i < me.infcontainers.length; i++){
                                an = an + 1;
                                if(x.idcontenedor == me.infcontainers[i].idtype && x.idtamano == me.infcontainers[i].idsize ){
                                    //for(n=0; n < me.infcontainers[i].number; n++){  
                                        if(x.idcontenedor == me.infcontainers[i].idtype && x.idtamano == me.infcontainers[i].idsize ){
                                            me.buysellBt.push({
                                                num:an,
                                                buysell:x.buysell,
                                                charge:x.charge,
                                                collect:x.collect,
                                                idbs:x.idbs,
                                                idcharge:x.idcharge,
                                                idchargebs:x.idchargebs,
                                                idcontenedor:x.idcontenedor,
                                                idcustomer:x.idcustomer,
                                                idinstance:x.idinstance,
                                                idiva:x.idiva,
                                                idmoneda:x.idmoneda,
                                                idprovider:x.idprovider,
                                                idtamano:x.idtamano,
                                                idtipocambio:x.idtipocambio,
                                                iva:x.iva,
                                                moneda:x.moneda,
                                                notas:x.notas,
                                                per:x.payment,
                                                payment:x.payment,
                                                prepaid:x.prepaid,
                                                provider:x.provider,
                                                quantity:x.quantity,
                                                rate:x.rate,
                                                tamanoc:x.tamanoc,
                                                tipoc:x.tipoc,
                                                total:x.total,
                                                totalmxn:totalmxn,
                                                invoice:x.invoice
                                            });
                                            tbuyiva = Number(tbuyiva) + Number(x.total);
                                            if(x.prepaid != 0){
                                                tbuy = Number(tbuy) + Number(x.prepaid);
                                            }
                                            if(x.collect != 0){
                                                tbuy = Number(tbuy) + Number(x.collect);
                                            }   
                                        }
                                    //}
                                }
                           //}
                        }else{
                            if(x.payment == 'TON/m3'){
                                var costo;
                                var iva;   
                                var total;
                                if(me.pesovolumen >= me.actualw){
                                    if(x.prepaid !=''){
                                        costo = me.pesovolumen * x.prepaid;
                                    }else{
                                        costo = me.pesovolumen * x.collect;
                                    }
                                }else{
                                    if(x.prepaid !=''){
                                        costo = me.actualw * x.prepaid;
                                    }else{
                                        costo = me.actualw * x.collect;
                                    }
                                }
                                iva = Number(costo) * 0.16;
                                total = Number(costo) + Number(iva);
                                an = an + 1;
                                me.buysellBt.push({
                                    num:an,
                                    buysell:x.buysell,
                                    charge:x.charge,
                                    collect:x.collect,
                                    idbs:x.idbs,
                                    idcharge:x.idcharge,
                                    idchargebs:x.idchargebs,
                                    idcontenedor:x.idcontenedor,
                                    idcustomer:x.idcustomer,
                                    idinstance:x.idinstance,
                                    idiva:x.idiva,
                                    idmoneda:x.idmoneda,
                                    idprovider:x.idprovider,
                                    idtamano:x.idtamano,
                                    idtipocambio:x.idtipocambio,
                                    iva:x.iva,
                                    moneda:x.moneda,
                                    notas:x.notas,
                                    per:x.payment,
                                    payment:x.payment,
                                    prepaid:x.prepaid,
                                    provider:x.provider,
                                    quantity:x.quantity,
                                    rate:x.rate,
                                    tamanoc:x.tamanoc,
                                    tipoc:x.tipoc,
                                    total:total,
                                    totalmxn:totalmxn,
                                    invoice:x.invoice
                                });
                            }else{
                                an = an + 1;
                                me.buysellBt.push({
                                    num:an,
                                    buysell:x.buysell,
                                    charge:x.charge,
                                    collect:x.collect,
                                    idbs:x.idbs,
                                    idcharge:x.idcharge,
                                    idchargebs:x.idchargebs,
                                    idcontenedor:x.idcontenedor,
                                    idcustomer:x.idcustomer,
                                    idinstance:x.idinstance,
                                    idiva:x.idiva,
                                    idmoneda:x.idmoneda,
                                    idprovider:x.idprovider,
                                    idtamano:x.idtamano,
                                    idtipocambio:x.idtipocambio,
                                    iva:x.iva,
                                    moneda:x.moneda,
                                    notas:x.notas,
                                    per:x.payment,
                                    payment:x.payment,
                                    prepaid:x.prepaid,
                                    provider:x.provider,
                                    quantity:x.quantity,
                                    rate:x.rate,
                                    tamanoc:x.tamanoc,
                                    tipoc:x.tipoc,
                                    total:x.total,
                                    totalmxn:totalmxn,
                                    invoice:x.invoice
                                });
                            }
                            tbuyiva = Number(tbuyiva) + Number(x.total);
                            if(x.prepaid != 0){
                                tbuy = Number(tbuy) + Number(x.prepaid);
                            }
                            if(x.collect != 0){
                                tbuy = Number(tbuy) + Number(x.collect);
                            }
                        }
                    });
                    me.totalbuyiva = parseFloat(Number(tbuyiva)).toFixed(2);
                    me.totalbuy = parseFloat(Number(tbuy)).toFixed(2);
                        axios.get('api/chargesBS/ListarChargesSell/' + idbs,configuracion).then(async function(response){
                            sell=response.data;
                            console.log(sell)
                            me.costossell = response.data;
                            var fin = 0;
                            var id = 0;
                            sell.map(async function(x){
                                id = id + 1;
                                var totalmxn = 0;
                                if(x.cobrarenpesos == true){
                                    totalmxn = x.totalmxn;
                                }
                                if(x.payment == 'container'){
                                        //for(i=0; i < me.infcontainers.length; i++){
                                            //if(x.idcontenedor == me.infcontainers[i].idtype && x.idtamano == me.infcontainers[i].idsize ){
                                                //for(n = 0; n < me.infcontainers[i].number; n++){
                                                    ans = ans + 1; 
                                                    me.buysellst.push({
                                                        id:id,
                                                        num:ans,
                                                        buysell:x.buysell,
                                                        charge:x.charge,
                                                        collect:x.collect,
                                                        idbs:x.idbs,
                                                        idcharge:x.idcharge,
                                                        idchargebs:x.idchargebs,
                                                        idcontenedor:x.idcontenedor,
                                                        idcustomer:x.idcustomer,
                                                        idinstance:x.idinstance,
                                                        idiva:x.idiva,
                                                        idmoneda:x.idmoneda,
                                                        idprovider:x.idprovider,
                                                        idtamano:x.idtamano,
                                                        idtipocambio:x.idtipocambio,
                                                        iva:x.iva,
                                                        moneda:x.moneda,
                                                        notas:x.notas,
                                                        per:x.payment,
                                                        payment:x.payment,
                                                        prepaid:x.prepaid,
                                                        provider:x.provider,
                                                        quantity:x.quantity,
                                                        rate:x.rate,
                                                        tamanoc:x.tamanoc,
                                                        tipoc:x.tipoc,
                                                        ntotal:x.total,
                                                        total:x.total,
                                                        totalmxn:totalmxn,
                                                        invoice:x.invoice
                                                    });
                                                    tselliva = Number(tselliva) + Number(x.total);
                                                    if(x.prepaid != 0){
                                                        tsell = Number(tsell) + Number(x.prepaid);
                                                    }
                                                    if(x.collect != 0){
                                                        tsell = Number(tsell) + Number(x.collect);
                                                    }
                                                //}
                                            //}
                                        //}
                                }else{
                                    if(x.payment == 'TON/m3'){
                                            var costo;
                                            var iva;   
                                            var total;  
                                            
                                            if(me.pesovolumen >= me.actualw){
                                                if(x.prepaid !=''){
                                                    costo = me.pesovolumen * x.prepaid;
                                                }else{
                                                    costo = me.pesovolumen * x.collect;
                                                }
                                            }else{
                                                if(x.prepaid !=''){
                                                    costo = me.actualw * x.prepaid;
                                                }else{
                                                    costo = me.actualw * x.collect;
                                                }
                                            }
                                            iva = Number(costo) * 0.16;
                                            total = Number(costo) + Number(iva);
                                            an = an + 1;
                                            me.buysellst.push({
                                                id:id,
                                                num:ans,
                                                buysell:x.buysell,
                                                charge:x.charge,
                                                collect:x.collect,
                                                idbs:x.idbs,
                                                idcharge:x.idcharge,
                                                idchargebs:x.idchargebs,
                                                idcontenedor:x.idcontenedor,
                                                idcustomer:x.idcustomer,
                                                idinstance:x.idinstance,
                                                idiva:x.idiva,
                                                idmoneda:x.idmoneda,
                                                idprovider:x.idprovider,
                                                idtamano:x.idtamano,
                                                idtipocambio:x.idtipocambio,
                                                iva:x.iva,
                                                moneda:x.moneda,
                                                notas:x.notas,
                                                per:x.payment,
                                                payment:x.payment,
                                                prepaid:x.prepaid,
                                                provider:x.provider,
                                                quantity:x.quantity,
                                                rate:x.rate,
                                                tamanoc:x.tamanoc,
                                                tipoc:x.tipoc,
                                                ntotal:x.total,
                                                total:total,
                                                totalmxn:totalmxn,
                                                invoice:x.invoice
                                            });
                                            tselliva = Number(tselliva) + Number(x.total);
                                            if(x.prepaid != 0){
                                                tsell = Number(tsell) + Number(x.prepaid);
                                            }
                                            if(x.collect != 0){
                                                tsell = Number(tsell) + Number(x.collect);
                                            }
                                    }else{
                                        ans = ans + 1;
                                        me.buysellst.push({
                                            id:id,
                                            num:ans,
                                            buysell:x.buysell,
                                            charge:x.charge,
                                            collect:x.collect,
                                            idbs:x.idbs,
                                            idcharge:x.idcharge,
                                            idchargebs:x.idchargebs,
                                            idcontenedor:x.idcontenedor,
                                            idcustomer:x.idcustomer,
                                            idinstance:x.idinstance,
                                            idiva:x.idiva,
                                            idmoneda:x.idmoneda,
                                            idprovider:x.idprovider,
                                            idtamano:x.idtamano,
                                            idtipocambio:x.idtipocambio,
                                            iva:x.iva,
                                            moneda:x.moneda,
                                            notas:x.notas,
                                            per:x.payment,
                                            payment:x.payment,
                                            prepaid:x.prepaid,
                                            provider:x.provider,
                                            quantity:x.quantity,
                                            rate:x.rate,
                                            tamanoc:x.tamanoc,
                                            tipoc:x.tipoc,
                                            ntotal:x.total,
                                            total:x.total,
                                            totalmxn:totalmxn,
                                            invoice:x.invoice
                                        });
                                        tselliva = Number(tselliva) + Number(x.total);
                                        if(x.prepaid != 0){
                                            tsell = Number(tsell) + Number(x.prepaid);
                                        }
                                        if(x.collect != 0){
                                            tsell = Number(tsell) + Number(x.collect);
                                        }
                                    }   
                                }
                                fin = fin + 1;
                            });
                                            
                            me.totalselliva = parseFloat(Number(tselliva)).toFixed(2);
                            me.totalsell = parseFloat(Number(tsell)).toFixed(2);
                        }).catch(function(error){
                            console.log(error);
                        });
                        me.dialodload = false;
                        me.viewdatos = true;
                        
                    }).catch(function(error){
                        console.log(error);
                    });
            },0 | Math.random() * 2500);
        },
        ListarChargeBS(idbs){
            var buy = [];
            var sell = [];
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this; 
            axios.get('api/chargesBS/ListarChargesBuy/' + idbs,configuracion).then(function(response){  
                var totalBuy = 0;                          
                me.buysellB = response.data;
                console.log(me.buysellB)
                buy = response.data;
                buy.map(function(x){
                    totalBuy = totalBuy + x.total;
                    
                });
                    
                me.totalBuy = totalBuy;
                me.idtotalbuy1 = parseFloat(me.totalBuy).toFixed(2);
                me.idtotalbuy = "$ " + me.addCommas(me.idtotalbuy1)


                me.idtotal1 = parseFloat(me.idtotalsell1).toFixed(2) - parseFloat(me.idtotalbuy1).toFixed(2);
                me.idtotal = parseFloat(me.idtotal1).toFixed(2);
                me.idtotal = '$ ' + me.addCommas(me.idtotal)
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/chargesBS/ListarChargesSell/' + idbs,configuracion).then(function(response){                            
                me.buysells=response.data;
                console.log(me.buysells)
                sell = response.data;
                var totalsell = 0;
                sell.map(function(x){
                    totalsell = totalsell + x.total
                })
                me.totalSell = totalsell;
                me.idtotalsell1 = parseFloat(me.totalSell).toFixed(2);
                me.idtotalsell = '$ ' + me.addCommas(me.idtotalsell1)
                console.log(me.totalSell)

                me.idtotal1 = parseFloat(me.idtotalsell1).toFixed(2) - parseFloat(me.idtotalbuy1).toFixed(2);
                me.idtotal = parseFloat(me.idtotal1).toFixed(2);
                me.idtotal = '$ ' + me.addCommas(me.idtotal)
            }).catch(function(error){
                console.log(error);
            });
        },
        async cargarinfocontainer(){
            this.tarifasListarinfo = [];
            var i=0;
            for(i = 0; i < this.tarifasListar.length; i++){
                if(this.tarifasListar[i].activo == true){
                    this.tarifasListarinfo.push({
                        num:this.tarifasListar[i].num,
                        qty:this.tarifasListar[i].qty,
                        idpackage:this.tarifasListar[i].idpackage,
                        idpackagen:this.tarifasListar[i].idpackagen,
                        package:this.tarifasListar[i].idpackagen,
                        size:this.tarifasListar[i].size,
                        type:this.tarifasListar[i].type,
                        idsize:this.tarifasListar[i].idsize,
                        idtype:this.tarifasListar[i].idtype,
                        qtycontainers:this.tarifasListar[i].qtycontainers,
                        containernumber:this.tarifasListar[i].containernumber,
                        sel:this.tarifasListar[i].sel,
                        vol:this.tarifasListar[i].vol,
                        ngross:this.addCommas(parseFloat(this.tarifasListar[i].gross).toFixed(2)) + " Kg.",
                        gross:this.tarifasListar[i].gross,
                        hbln:this.tarifasListar[i].hbln,
                        idhbl:this.tarifasListar[i].idhbl,
                        idhbln:this.tarifasListar[i].idhbln,
                        mbln:this.tarifasListar[i].mbln,
                        idmbl:this.tarifasListar[i].idmbl,
                        idmbln:this.tarifasListar[i].idmbln,
                        description:this.tarifasListar[i].description,
                        length:this.tarifasListar[i].length,
                        width:this.tarifasListar[i].width,
                        height:this.tarifasListar[i].height,
                        activo:true,
                    })
                }
            }
        },
        async informaciondeembarque(){
            this.dialodload=true;
            var i = 0;
            var j = 0;
            var hbl='';
            var hb = '';
            var mb = '';
            var hbc = '';
            var mbc = '';
            var containernumber='';
            var container = [];
            this.hblnum='';
            this.ncontainer ='';
            this.numbercontainer='';
            this.mblhnl = [];
            var nueva = false;
            for(i = 0; i< this.tarifasListar.length; i++){
                if(this.tarifasListar[i].hbln != ''){
                    if(this.tarifasListar[i].hbln != hbl){
                        if(this.hblnum == ''){
                            this.hblnum = this.tarifasListar[i].hbln;
                        }else{
                            this.hblnum = this.hblnum + ' / ' + this.tarifasListar[i].hbln; 
                        }
                    }
                }
                if(this.tarifasListar[i].containernumber != ''){
                    if(this.tarifasListar[i].containernumber != containernumber){
                        if(this.numbercontainer == ''){
                            this.numbercontainer = this.tarifasListar[i].containernumber;
                        }else{
                            this.numbercontainer = this.numbercontainer + ' / ' + this.tarifasListar[i].containernumber; 
                        }
                    }
                }
                if(container.length > 0){
                    for(j=0; j < container.length; j++){
                        if(container[j].size == this.tarifasListar[i].size){
                            Object.assign(container[j], {
                                cat:container[j].cat + 1,
                                size:this.tarifasListar[i].size,
                                type:this.tarifasListar[i].type,
                            });
                        }else{
                            if(nueva == false){
                                container.push({
                                    cat:0,
                                    size:this.tarifasListar[i].size,
                                    type:this.tarifasListar[i].type,
                                })
                                nueva = true;
                            }
                        }
                    }
                }else{
                    container.push({
                        cat:1,
                        size:this.tarifasListar[i].size,
                        type:this.tarifasListar[i].type,
                    })
                }
                hbl = this.tarifasListar[i].hbln;
                containernumber = this.tarifasListar[i].containernumber;
                if(this.tarifasListar[i].hbln != ''|| this.tarifasListar[i].mbln != ''){
                    if(this.tarifasListar[i].hbln != hb || this.tarifasListar[i].mbln != mb){
                        if(this.tarifasListar[i].idhbln != hbc || this.tarifasListar[i].idmbln != mbc){
                            this.mblhnl.push({
                                hbln:this.tarifasListar[i].hbln,
                                idhbln:this.tarifasListar[i].idhbln,
                                mbln:this.tarifasListar[i].mbln,
                                idmbln: this.tarifasListar[i].idmbln
                            })
                        }
                    }

                }
                hb = this.tarifasListar[i].hbln;
                hbc = this.tarifasListar[i].idhbln;
                mb = this.tarifasListar[i].mbln;
                mbc = this.tarifasListar[i].idmbln

            }
            var k = 0;
            var prefix='';
            for(k=0; k < container.length; k++ ){
                console.log('container[k].type ')
                console.log(container[k].type )
                if(container[k].type == 'DRY CARGO'){
                    prefix='DC';
                }
                if(container[k].type == 'HIGH CUBE'){
                    prefix='HC';
                }
                if(prefix ==''){
                    prefix = container[k].type;
                }
                if(this.ncontainer == ''){
                    this.ncontainer = container[k].cat + 'x'+ container[k].size +' ' +prefix    
                }else{
                    this.ncontainer = this.ncontainer + ' / '+ container[k].cat + 'x'+ container[k].size +' ' +prefix
                }
            }
        },
        name(){
            return this.$store.state.usuario.nombre + ' ' + this.$store.state.usuario.apellido;
        },
        fechahoy(){
            const date = new Date()
            const dateTimeFormat = new Intl.DateTimeFormat('Mx', { year: 'numeric', month: 'long', day: '2-digit' }) 
            const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat .formatToParts(date ) 
            this.fechaHoy = `${month} de ${day} del ${year }`;
            console.log(`${day}-${month}-${year }`);
        },
        addCommas(nStr) {
            nStr += '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        },
    }   
}
</script>